import { useCommandPalette } from '@components/Common/CommandPalette/CommandPaletteProvider';
import NotificationBell from '@components/NotificationBell';
import SearchIcon from '@mui/icons-material/Search';
import { Box } from '@mui/material';
import React from 'react';
import './index.scss';

/**
 * Dark app-shell top bar (52px).
 *
 * The search slot is a button, not an input. As a text field it would only
 * duplicate the per-page SearchFilter panel; as a command-palette trigger it
 * spans all 17 sections, which is the thing no per-page filter can do.
 */
const Topbar: React.FC = () => {
  const { open } = useCommandPalette();

  return (
    <Box className="cc-topbar" component="header">
      <button
        className="cc-topbar__search"
        onClick={open}
        type="button"
        aria-label="Open command palette"
      >
        <SearchIcon className="cc-topbar__search-icon" />
        <span className="cc-topbar__search-label">
          Jump to job, company, seeker, application…
        </span>
        <span className="cc-topbar__kbd">⌘K</span>
      </button>

      <Box className="cc-topbar__spacer" />

      <Box className="cc-topbar__actions">
        <NotificationBell />
      </Box>
    </Box>
  );
};

export default Topbar;
